import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PublicRoute from './hoc/publicRoute';
import Home from './components/home';
import SignIn from './components/account/signin';
import Overview from './components/overview';
import PrivateRoute from './hoc/privateRoute';
import Events from './components/events';
import Event from './components/events/event';
import Section from './components/section';
import SignUp from './components/account/signup';
import NewGame from './components/games/newGame';
import Scoring from './components/games/scoring';
import Scoreboard from './components/scoreboard';
import ForgotPassword from './components/account/forgotPassword';
import ResetPassword from './components/account/resetPassword';
import { Roles } from './helpers/access';
import Scorecard from './components/scoreboard/scorecard';
import UserProfileCreate from './components/account/userProfileCreate';
import Log from './components/scoreboard/log';
import EmbeddedScores from './components/embedded/embeddedEventScores';
import Users from './components/users';
import Invite from './components/account/invite';
import PhoneAuth from './components/account/phoneAuth';
import PublicScoreView from './components/games/publicScoreView';
import Bracket from './components/bracket';
import LiveScore from './components/embedded/overlays/liveScore';
import OverlayRoute from './hoc/overlayRoute';
import LiveTicker from './components/embedded/overlays/liveTicker';
import OverlayIndex from './components/embedded/overlays/overlayIndex';
import OverlayEventsList from './components/embedded/overlays/overlayEventsList';
import SectionScorecardsOverlay from './components/embedded/overlays/sectionScorecardsOverlay';
import GameScorecardOverlay from './components/embedded/overlays/gameScorecardOverlay';
import LiveScorecardEvent from './components/embedded/overlays/liveScorecardEvent';
import EventArchive from './components/events/archive';
import MyGames from './components/myGames';
import Tournaments from './components/tournaments';
import TournamentCreate from './components/tournaments/create';
import PrintGreensQRCodes from './components/greens/printGreensQRCodes';
import GreenPatternManager from './components/greens/patternManager';
import PublicScoringRink from './components/publicScoring/publicScoringRink';
import PublicScoring from './components/publicScoring/publicScoring';
import ForTVLogs from './components/embedded/forTvLogs';
import GreenOrganiser from './components/greenorganiser';
import PlayerOpponents from './components/events/playerOpponents';
import EventAllGames from './components/events/eventAllGames';
import EventAuditPage from './components/events/audit/eventAuditPage';
import ForTVLogsScrolling from './components/embedded/forTvLogsScrolling';
import GroupMatchup from './components/embedded/groupMatchup';
import GroupMatchupTVOverlay from './components/embedded/groupMatchupTVOverlay';
import PrintSectionQRCodes from './components/section/printSectionQRCodes';
import PublicScoringSection from './components/publicScoring/publicScoringSection';
import PublicScoringEventsList from './components/publicScoring/publicScoringEventsList';
import PublicScoringAllGames from './components/publicScoring/publicScoringAllGames';
import EmbeddedPlayerGames from './components/embedded/playerGames';
import QuickGameCreate from './components/quickGameCreate';
import LiveScoreEvent from './components/embedded/overlays/liveScoreEvent';
import HorizontalLiveScoreEvent from './components/embedded/overlays/horizontalLiveScoreEvent';
import WorkspaceSettings from './components/workspace';
import Profile from './components/account/profile';
import Settings from './components/settings';
import Support from './components/support';
import PortalGate from './components/portal/portalGate';
import PortalSections from './components/portal/portalSections';
import PortalClubs from './components/portal/portalClubs';
import PortalGames from './components/portal/portalGames';
import PortalGame from './components/portal/portalGame';
import PortalAdmin from './components/portal/portalAdmin';
import PortalQrPrint from './components/portal/portalQrPrint';

// import PrivateRoute from './hoc/privateRoute';
// import PublicRoute from './hoc/publicRoute';

//Auth
// import ForgotPassword from './components/account/forgotPassword';
// import SignIn from './components/account/signin';
// import SignUp from './components/account/signup';
// import UpdatePassword from './components/account/updatePassword';

const MainRoutes = (props) => {
  return (
    <Routes>
      <Route element={<PrivateRoute role={Roles.USER} />}>
        <Route path={'/overview'} element={<Overview />} />
        <Route path={'/my-games'} element={<MyGames />} />

        <Route path={'/new'} element={<NewGame />} />
        <Route path={'/tournaments'} element={<Tournaments />} />
        <Route path={'/tournaments/create'} element={<TournamentCreate />} />
        <Route path={'/events'} element={<Events />} />
        <Route path={'/events/archive'} element={<EventArchive />} />
        <Route path={'/events/:eventId'} element={<Event />} />
        <Route path={'/events/:eventId/section/:sectionId'} element={<Section />} />
        <Route path={'/events/:eventId/scoreboard'} element={<Scoreboard />} />
        <Route path={'/events/:eventId/log'} element={<Log />} />
        <Route path={'/events/:eventId/scorecard'} element={<Scorecard />} />
        <Route path={'/events/:eventId/bracket'} element={<Bracket />} />
        <Route path={'/events/:eventId/games'} element={<EventAllGames />} />
        <Route path={'/events/:eventId/audit'} element={<EventAuditPage />} />
        <Route path={'/events/:eventId/greens'} element={<GreenOrganiser />} />
        <Route path={'/green-patterns'} element={<GreenPatternManager />} />
        <Route path={'/events/:eventId/greens/printqrcodes'} element={<PrintGreensQRCodes />} />
        <Route path={'/events/:eventId/sections/printqrcodes'} element={<PrintSectionQRCodes />} />
        <Route path={'/events/:eventId/player-opponents'} element={<PlayerOpponents />} />
        <Route path={'/events/:eventId/overlays'} element={<OverlayIndex />} />
        <Route path={'/events/:eventId/portals'} element={<PortalAdmin />} />
        <Route path={'/workspace-settings'} element={<WorkspaceSettings />} />
        <Route path={'/workspace-settings/:workspaceId'} element={<WorkspaceSettings />} />
        <Route path={'/profile'} element={<Profile />} />
        <Route path={'/support'} element={<Support />} />
        <Route path={'/game/scoring/:gameId'} element={<Scoring />} />
      </Route>

      <Route element={<PrivateRoute role={Roles.ADMIN} />}>
        <Route path={'/users'} element={<Users />} />
      </Route>

      <Route element={<PrivateRoute role={Roles.SUPERUSER} />}>
        <Route path={'/settings'} element={<Settings />} />
      </Route>

      {/* PIN-protected event portals. These must stay outside PublicRoute so a
          signed-in organiser can still open an official's link. */}
      <Route path={'/portal/:eventId/club/:venueId'} element={<PortalGate kind="club" />}>
        <Route index element={<PortalSections mode="club" />} />
        <Route path={'print/rinks'} element={<PortalQrPrint sheet="rinks" mode="club" />} />
        <Route
          path={'print/sections'}
          element={<PortalQrPrint sheet="sections" mode="club" />}
        />
        <Route path={'sections/:sectionId'} element={<PortalGames mode="club" />} />
        <Route
          path={'sections/:sectionId/games/:gameId'}
          element={<PortalGame mode="club" />}
        />
      </Route>

      <Route path={'/portal/:eventId/secretary'} element={<PortalGate kind="secretary" />}>
        <Route index element={<PortalClubs />} />
        <Route path={'access'} element={<PortalAdmin mode="portal" />} />
        <Route
          path={'print/rinks'}
          element={<PortalQrPrint sheet="rinks" mode="secretary" />}
        />
        <Route
          path={'print/sections'}
          element={<PortalQrPrint sheet="sections" mode="secretary" />}
        />
        <Route path={'clubs/:venueId'} element={<PortalSections mode="secretary" />} />
        <Route
          path={'clubs/:venueId/sections/:sectionId'}
          element={<PortalGames mode="secretary" />}
        />
        <Route
          path={'clubs/:venueId/sections/:sectionId/games/:gameId'}
          element={<PortalGame mode="secretary" />}
        />
      </Route>

      <Route element={<PublicRoute />}>
        <Route path={'/'} element={<Home />} />
        <Route path={'/signin'} element={<SignIn />} />
        <Route path={'/signup'} element={<SignUp />} />
        <Route path={'/phone-auth'} element={<PhoneAuth />} />
        <Route path={'/create-profile'} element={<UserProfileCreate />} />
        <Route path={'/invite/:inviteToken'} element={<Invite />} />
        <Route path={'/forgot-password'} element={<ForgotPassword />} />
        <Route path={'/reset-password/:token'} element={<ResetPassword />} />

        <Route path={'/embed/event/:eventId'} element={<EmbeddedScores />} />
        <Route path={'/embed/tvlogs/:eventId'} element={<ForTVLogs />} />
        <Route path={'/embed/tvlogsscrolling/:eventId'} element={<ForTVLogsScrolling />} />
        <Route path={'/embed/groupmatch/:eventId'} element={<GroupMatchup />} />
        <Route path={'/embed/groupmatch-tv/:eventId'} element={<GroupMatchupTVOverlay />} />
        {/* <Route path={'/embed/games/:sectionId'} element={<EmbeddedSectionsGames />} /> */}
        <Route path={'/embed/games/:gameId'} element={<PublicScoreView />} />
      </Route>

      <Route element={<OverlayRoute />}>
        <Route path={'/overlay-index/events'} element={<OverlayEventsList />} />
        <Route path={'/overlay-index/:eventId'} element={<OverlayIndex />} />
        <Route path={'/create'} element={<QuickGameCreate />} />
        <Route path={'/public/mygames/:bsaNumber'} element={<EmbeddedPlayerGames />} />
        <Route path={'/public/quickgames/:bsaNumber'} element={<EmbeddedPlayerGames pageMode="quick" />} />
        <Route path={'/embed/live/:eventId'} element={<LiveScoreEvent />} />
        <Route path={'/embed/horizontallive/:eventId'} element={<HorizontalLiveScoreEvent />} />
        <Route path={'/embed/scorecard-live/:eventId'} element={<LiveScorecardEvent />} />
        <Route path={'/embed/live-game/:gameId'} element={<LiveScore />} />
        <Route path={'/embed/scorecard/:gameId'} element={<GameScorecardOverlay />} />
        <Route path={'/embed/ticker/:eventId'} element={<LiveTicker />} />
        <Route
          path={'/embed/section-scorecards/:eventId/:sectionId'}
          element={<SectionScorecardsOverlay />}
        />

        <Route path={'/public/scoring/:eventId/:greenRink'} element={<PublicScoringRink />} />
        <Route
          path={'/public/scoring/:eventId/:venueId/:greenRink'}
          element={<PublicScoringRink />}
        />
        <Route
          path={'/public/scoring/:eventId/section/:sectionId'}
          element={<PublicScoringSection />}
        />
        <Route path={'/public/scoring-game/:gameId'} element={<PublicScoring />} />
        <Route path={'/public-scoring/events'} element={<PublicScoringEventsList />} />
        <Route path={'/public-scoring/event/:eventId'} element={<PublicScoringAllGames />} />
      </Route>
    </Routes>
  );
};

export default MainRoutes;
